import AddOrEditWarranty from "../common/add-or-edit-warranty";

export default function AddOrEditOwnerLogbookWarranty() {
  return <AddOrEditWarranty />;
}
